(() => {
  const getNewsletterWrapper = (form) => {
    if (!form) return null;

    return form.closest('.footer__newsletter, .megamenu__newsletter');
  };

  const showNewsletterMessage = (form, type = 'success') => {
    if (!form) return;

    const wrapper = getNewsletterWrapper(form);
    if (!wrapper) return;

    const message = wrapper.querySelector('.js-footer-newsletter-message');
    if (!message) return;

    const text =
      type === 'success'
        ? message.dataset.successMessage || 'Thank you for subscribing.'
        : message.dataset.errorMessage || 'Something went wrong. Please try again.';

    message.innerHTML = text;
    message.classList.toggle('is-success', type === 'success');
    message.classList.toggle('is-error', type === 'error');
  };

  const getNewsletterFormFromUrl = () => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('customer_posted') !== 'true') return null;

    const hash = window.location.hash.replace('#', '');

    // The email-capture popup rides the same customer_posted redirect; it owns
    // its own success UI, so don't also show the footer newsletter message.
    if (hash === 'email-capture-success') return null;

    if (hash) {
      const hashElement = document.getElementById(hash);

      if (hashElement) {
        if (hashElement.matches('.js-footer-newsletter')) {
          return hashElement;
        }

        const formInside = hashElement.querySelector?.('.js-footer-newsletter');
        if (formInside) return formInside;

        const wrapper = hashElement.closest?.(
          '.footer__newsletter, .megamenu__newsletter'
        );

        const formInWrapper = wrapper?.querySelector('.js-footer-newsletter');
        if (formInWrapper) return formInWrapper;
      }
    }

    return document.querySelector('.js-footer-newsletter');
  };

  document.addEventListener('DOMContentLoaded', () => {
    const form = getNewsletterFormFromUrl();
    if (!form) return;

    showNewsletterMessage(form, 'success');

    const wrapper = getNewsletterWrapper(form);

    if (wrapper) {
      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('.js-footer-newsletter');
      if (!form) return;

      // Our own submit below re-fires this event; let it through to the browser
      // + Shopify's hCaptcha natively.
      if (form.dataset.newsletterNativeSubmit === 'true') {
        return;
      }

      const wrapper = getNewsletterWrapper(form);
      if (!wrapper) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.classList.add('is-loading');
      }

      // Tag the action with this form's id so the customer_posted redirect can
      // restore the success message for THIS form after the reload.
      const actionUrl = (form.getAttribute('action') || '/contact').split('#')[0] || '/contact';
      const hashId = form.id || wrapper.id || `newsletter-${Date.now()}`;
      if (!form.id) {
        form.id = hashId;
      }
      form.setAttribute('action', `${actionUrl}#${hashId}`);
      form.dataset.newsletterNativeSubmit = 'true';

      const submit = () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else if (submitButton) {
          submitButton.click();
        }
      };

      // Submit natively so Shopify's captcha — governed entirely by the store's
      // spam-protection preference — runs and attaches a token. When enabled
      // this is usually an invisible (challenge-free) token; when disabled,
      // protect() is absent and we submit plainly. Either way the store
      // preference decides the behavior.
      const captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function') {
        captcha.protect(form, submit);
      } else {
        submit();
      }
    },
    true
  );
})();